import Helper from '@ember/component/helper';
import { type Registry as Services, service } from '@ember/service';
import { contextualPageTitle as upstreamContextualPageTitle } from 'frontend-utils';
import { FEATURE_TOGGLES } from 'lumen/utils/constants/feature-toggle-constants';

interface ContextualPageTitleSignature {
  Args: {
    Positional: [pageName: string, context?: string];
  };
  Return: string;
}

export default class ContextualPageTitleHelper extends Helper<ContextualPageTitleSignature> {
  @service declare destination: Services['destination'];
  @service declare featureToggle: Services['feature-toggle'];
  @service('hotel-and-market')
  declare hotelAndMarketService: Services['hotel-and-market'];

  compute([
    pageName,
    context,
  ]: ContextualPageTitleSignature['Args']['Positional']): ContextualPageTitleSignature['Return'] {
    const hasContextualTabNaming = this.featureToggle.hasFeatureToggle(
      FEATURE_TOGGLES.CONTEXTUAL_TAB_NAMING,
    );

    if (!hasContextualTabNaming) {
      return 'Lighthouse';
    }

    if (context) {
      return upstreamContextualPageTitle(pageName, context);
    }

    const { hotel, market } = this.hotelAndMarketService;

    if (hotel) {
      const { name: hotelName, brandCode } = hotel.hotelinfo;

      if (!brandCode || this.hotelAndMarketService.isDemoModeActive) {
        return upstreamContextualPageTitle(pageName, hotelName);
      }

      return upstreamContextualPageTitle(
        pageName,
        `${brandCode} - ${hotelName}`,
      );
    }

    if (market) {
      return upstreamContextualPageTitle(pageName, market.displayName);
    }

    const { destinationSubscription } = this.destination;

    if (destinationSubscription) {
      return upstreamContextualPageTitle(
        pageName,
        destinationSubscription.name,
      );
    }

    return 'Lighthouse';
  }
}
